export default "__VITE_ASSET__uBq5zyd7__"